import { Link } from 'react-router-dom';

import ContentPage from '../components/ui/ContentPage';

interface SiteSection {
  heading: string;
  links: { label: string; to: string; external?: boolean }[];
}

const SECTIONS: SiteSection[] = [
  {
    heading: 'Marketplace',
    links: [
      { label: 'Catálogo de animais', to: '/marketplace' },
      { label: 'As miñas compras', to: '/marketplace/me/purchases' },
      { label: 'Vender un animal', to: '/marketplace/vender' },
    ],
  },
  {
    heading: 'Conta',
    links: [
      { label: 'Entrar', to: '/marketplace/login' },
      { label: 'Perfil e seguranza', to: '/marketplace/profile' },
      { label: 'Verificar email', to: '/marketplace/verify-email' },
      { label: 'Definir contrasinal', to: '/marketplace/setup-password' },
    ],
  },
  {
    heading: 'Información',
    links: [
      { label: 'Centro de axuda', to: '/marketplace/axuda' },
      { label: 'Contacto', to: '/marketplace/contacto' },
      { label: 'Seguridade da plataforma', to: '/marketplace/seguridade' },
      { label: 'Cumprimento (EUDR · PEPA)', to: '/marketplace/cumprimento' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Termos de uso', to: '/marketplace/termos' },
      { label: 'Política de privacidade', to: '/marketplace/privacidade' },
    ],
  },
  {
    heading: 'Fóra da SPA',
    links: [
      { label: 'chain.leyro.es — landing principal', to: 'https://chain.leyro.es', external: true },
      {
        label: 'api.chain.leyro.es/api/docs — OpenAPI',
        to: 'https://api.chain.leyro.es/api/docs',
        external: true,
      },
    ],
  },
];

export default function SitemapPage(): JSX.Element {
  return (
    <ContentPage title="Mapa do sitio" intro="Todas as páxinas accesibles do marketplace.">
      <div className="grid sm:grid-cols-2 gap-8 not-prose">
        {SECTIONS.map((s) => (
          <section key={s.heading}>
            <h3 className="text-base font-semibold text-dark mb-3">{s.heading}</h3>
            <ul className="space-y-2">
              {s.links.map((l) =>
                l.external ? (
                  <li key={l.label}>
                    <a
                      href={l.to}
                      className="text-sm text-dark hover:text-rauxa hover:underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {l.label} ↗
                    </a>
                  </li>
                ) : (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-dark hover:text-rauxa hover:underline">
                      {l.label}
                    </Link>
                  </li>
                ),
              )}
            </ul>
          </section>
        ))}
      </div>
    </ContentPage>
  );
}
